import { Inject, Injectable } from '@angular/core';
import type { RouterStateSnapshot } from '@angular/router';
import { TitleStrategy } from '@angular/router';
import { SITE_NAME } from '@freelancer/config';
import { TitleService } from './title.service';

@Injectable()
export class DefaultSitenameTitleStrategy extends TitleStrategy {
  constructor(
    private readonly titleService: TitleService,
    @Inject(SITE_NAME) private readonly siteName: string,
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    this.titleService.setTitle(title || this.siteName, !!title);
  }
}
